var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 5,
    fill: "#007EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2191 21.2756L6.76147 25.6786C5.74618 26.6814 5.74618 28.3075 6.76148 29.3103L13.6553 36.1197C16.1935 38.6268 20.309 38.6268 22.8472 36.1197L24.5472 34.4405M11.2191 21.2756L25.6718 7L39 20.1648L24.5472 34.4405M11.2191 21.2756L24.5472 34.4405",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.44a7ba2d04153adb5996b08f130e5aa7.svg";
export { ForwardRef as ReactComponent };